import { render, staticRenderFns } from "./playerCaseManage.vue?vue&type=template&id=007ba8a2&"
import script from "./playerCaseManage.vue?vue&type=script&lang=js&"
export * from "./playerCaseManage.vue?vue&type=script&lang=js&"
import style0 from "./playerCaseManage.vue?vue&type=style&index=0&id=007ba8a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports